module.exports = __webpack_public_path__ + "media/images/v2/fast-forward-f533dcfcf23606b39f9503291278684c.svg";